import styled from "styled-components";

interface StyledSettingsProps {
  $isVisible: boolean;
}

export const StyledSettings = styled.div<StyledSettingsProps>`
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  transform: ${(props) =>
    props.$isVisible ? "translateY(0)" : "translateY(20px)"};
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
  width: 100%;
  box-sizing: border-box;

  .settings-container {
    padding: 0 25px;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
      padding: 0 15px;
    }
  }
`;
